import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    // Definimos uma função nomeada para podermos referenciá-la se necessário
    Turbo.setConfirmMethod((message, element) => {
      return new Promise((resolve) => {
        Swal.fire({
          title: 'Você tem certeza?',
          html: message,
          icon: 'warning',
          iconColor: '#700d0d',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          buttonsStyling: false,
          reverseButtons: true,
          allowOutsideClick: () => !Swal.isLoading(), // Evita fechar durante carregamentos
          customClass: {
            popup: 'rounded-3 shadow-lg border-0',
            confirmButton: 'btn btn-primary px-4 py-2 me-2',
            cancelButton: 'btn btn-light text-secondary px-4 py-2 me-2'
          },
          // Remova ou simplifique as animações se o problema persistir, 
          // pois conflitos de CSS 'animate.css' podem travar o fechamento
        }).then((result) => {
          // Resolvemos a promessa para o Turbo continuar ou parar
          resolve(result.isConfirmed)

          // FORÇAR FECHAMENTO: Garante que o SWAL suma antes da navegação do Turbo
          if (result.isConfirmed) {
            Swal.close()
          }
        })
      })
    })
  }

  // Boa prática: limpar ao desconectar para evitar comportamentos estranhos
  disconnect() {
    Turbo.setConfirmMethod((message, element) => {
      return confirm(message)
    })
  }
}